import type { IncidentType } from '@/types';

const getActivePeriods = (incident: IncidentType, now: Date): IncidentType['activePeriod'] =>
  (incident.activePeriod ?? []).filter(({ end }) => new Date(end).getTime() >= now.getTime());

export default getActivePeriods;
